import taskRoutes from './task';

const operationRouters = [...taskRoutes];

export default operationRouters;
